import { Box, Button } from '@radix-ui/themes';
import { CustomIcon } from 'components/common/custom-icon';
import { CommonInputHint } from 'components/common/form/hint';
import { CommonInputLabel } from 'components/common/form/label';
import { CommonInputWrapper } from 'components/common/form/wrapper';
import { CustomIconPath } from 'enums/custom.enums';
import { t } from 'i18next';
import { ISwitchButtonInput } from 'interfaces/forms/switch-button';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { CSSProperties } from 'react';

// a component that resembles a select component, but with a switch icon that toggles based on the current value
export const CommonSwitchButton = (props: ISwitchButtonInput) => {
  const icon = props.value ? CustomIconPath.SwitchOn : CustomIconPath.SwitchOff;

  const color =
    props.inputColor ??
    // fallback to these defaults, based on value, if no color is provided
    (props.value ? RADIX.COLOR.ACCENT : RADIX.COLOR.SECONDARY);

  const variant = props.variant ?? (props.value ? 'soft' : 'outline');

  // ? use variant (instead of props.variant) to ensure we match what will be rendered
  const style: CSSProperties | undefined =
    variant === 'outline'
      ? {
          // fix the background color to match select and text input backgrounds
          backgroundColor: 'var(--color-surface)',
          // fix the border color to match select and text input borders
          boxShadow: 'inset 0 0 0 1px var(--accent-a7)',
        }
      : undefined;

  const switchPosition = props.switchPosition ?? 'left';

  const displayValue = props.value ? props.displayTrue : props.displayFalse;

  return (
    <CommonInputWrapper {...props}>
      <CommonInputLabel {...props} />

      <Box>
        <Button
          color={color}
          variant={variant}
          style={style}
          size={props.size}
          disabled={props.disabled}
          onClick={() => props.onChange(!props.value)}
        >
          {switchPosition === 'left' && <CustomIcon icon={icon} />}
          {t(displayValue)}
          {switchPosition === 'right' && <CustomIcon icon={icon} />}
        </Button>
      </Box>

      <CommonInputHint {...props} />
    </CommonInputWrapper>
  );
};
